import type { DeviceMicroconfiguration } from '@cobliteam/common-types';
import type { DeviceParameterInfoAPI, GetDeviceMicroconfigurationAPI } from './definitions';

/**
 * Indexa a lista de parâmetros por nome. A API devolve array; a página sempre consulta por nome,
 * então indexar aqui evita um `find` por campo em cada render.
 *
 * Parâmetro repetido não deveria acontecer (a Betoneira devolve um `Set`), mas se acontecer o
 * último vence — determinístico, em vez de depender da ordem de leitura de quem consome.
 */
const indexByName = (parameters?: DeviceParameterInfoAPI[] | null): Record<string, string> => {
  const indexed: Record<string, string> = {};

  for (const parameter of parameters ?? []) {
    indexed[parameter.name] = parameter.value;
  }

  return indexed;
};

export const toDeviceMicroconfiguration = (api: GetDeviceMicroconfigurationAPI): DeviceMicroconfiguration => ({
  deviceId: api.id,
  manufacturer: api.manufacturer,
  hardwareModel: api.type,
  target: indexByName(api.target_parameters),
  actual: indexByName(api.actual_parameters),
});
